import React, { useState } from "react";

const dummyDocuments = [
  { id: 1, name: "Document 1" },
  { id: 2, name: "Document 2" },
  { id: 3, name: "Document 3" },
  { id: 4, name: "Document 4" },
  { id: 5, name: "Document 5" },
  { id: 6, name: "Document 6" },
];
const DocumentsGrid: React.FC = () => {
  const [search, setSearch] = useState("");
  const filtered = dummyDocuments.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="mb-8">
      <div className="flex items-center mb-4">
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-1 border border-gray-300 rounded px-3 py-2 m-4 focus:outline-none"
        />
      </div>
      <div className="grid grid-cols-6 gap-4">
        {filtered.map((item) => (
          <div
            key={item.id}
            className="relative bg-gray-100 rounded-lg shadow hover:shadow-lg transition p-2 flex flex-col items-center border border-gray-200"
          >
            <div className="w-full h-20 flex items-center justify-center bg-black rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-12 h-12 text-white"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                />
              </svg>
              {/* <input
                type="checkbox"
                //checked={selected.includes(item.id)}
                //onChange={() => onSelect(item.id)}
                className="absolute top-2 right-2 w-4 h-4 accent-blue-600"
              /> */}
            </div>
            <div className="mt-2 w-full text-center text-sm font-medium truncate">
              {item.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsGrid;
